const Dim = () => {
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50" />;
};

export default Dim;
